import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import useScreenSize from "./hooks/UseScreenSize";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { AnnouncementProvider } from "./context/AnnouncementContext";
import { LoaderProvider } from "./context/LoaderContext";

import GlobalToast from "./components/common/GlobalToast";
import GlobalAnnouncement from "./components/common/GlobalAnnouncementToast";
import GlobalLoader from "./components/common/GlobalLoader";
import ErrorBoundary from "./components/common/ErrorBoundary";

import { SocketProvider } from "./context/SocketProvider";
import { NotificationProvider } from "./context/NotificationContext";
import { ThemeProvider } from "./context/ThemeContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { SettingsProvider } from "./context/SettingsContext";

const App: React.FC = () => {
  const isMobile = useScreenSize();

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <AnnouncementProvider>
            <LoaderProvider>
              <AuthProvider>
                <SubscriptionProvider>
                  <SettingsProvider>
                    <SocketProvider>
                      <NotificationProvider>
                        <BrowserRouter
                          future={{
                            v7_startTransition: true,
                            v7_relativeSplatPath: true,
                          }}
                        >
                          <style>
                            {isMobile ? "html, body { min-width: unset; }" : ""}
                          </style>

                          <AppRoutes />
                          <GlobalToast />
                          <GlobalAnnouncement />
                          <GlobalLoader />
                        </BrowserRouter>
                      </NotificationProvider>
                    </SocketProvider>
                  </SettingsProvider>
                </SubscriptionProvider>
              </AuthProvider>
            </LoaderProvider>
          </AnnouncementProvider>
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
